export default __webpack_public_path__ + "static/media/Steven Zhang.f2b52e0e.png";